
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11411",
                "data-name": "矩形 11411",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(-0.5 0)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_348",
        "data-name": "蒙版组 348",
        "class": "cls-2",
        "transform": "translate(0.5 0)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "dianreshuihu",
            "class": "cls-3",
            "d": "M68.917,88.933a20.356,20.356,0,0,0-2.346,10.125q0,.339.009.675H79.344q.008-.336.009-.675A20.349,20.349,0,0,0,77,88.925a1.175,1.175,0,0,1-.144.009Zm-.922-.141a1.285,1.285,0,0,1-.29-.208l-1.177-1.117a1.267,1.267,0,0,1-.307-1.349,1.169,1.169,0,0,1,1.09-.785h9.546a1.257,1.257,0,0,1,.96.451,3.963,3.963,0,0,1,3.755,4.049v5.4a.429.429,0,1,1-.857,0v-5.4a3.106,3.106,0,0,0-2.571-3.119v.869a1.381,1.381,0,0,1-.366.944,21.37,21.37,0,0,1,2.433,10.531q0,.339-.008.675h.084a1.759,1.759,0,0,1,1.714,1.8v.9a.879.879,0,0,1-.857.9H64.857a.879.879,0,0,1-.857-.9v-.9a1.759,1.759,0,0,1,1.714-1.8h.008q-.008-.337-.008-.675A21.743,21.743,0,0,1,67.995,88.792Zm-2.28,11.841a.879.879,0,0,0-.857.9v.9H81.143v-.9a.879.879,0,0,0-.857-.9ZM67.081,86.34a.336.336,0,0,0,.021.459l1.177,1.118a.417.417,0,0,0,.287.116h8.29a.44.44,0,0,0,.429-.45v-.9a.44.44,0,0,0-.429-.45H67.311A.3.3,0,0,0,67.081,86.34Z",
            "transform": "translate(-61 -82.334)"
          }
        }
      ]
    }
  ]
})
    }
  